export default "__VITE_ASSET__BYLLC$Xn__"